import { AdminInterFace } from "../../../Types";

export const adminFromLocalStg = (item: string = "admin"): AdminInterFace => {
  const adminString = localStorage.getItem(item);
  const admin: AdminInterFace = adminString ? JSON.parse(adminString) : null;
  return admin;
};
